import React from "react";
import { useIntl } from "react-intl";

import BankIDLogin from "@components/BankidComponent/BankIDLogin";
import Div from "@components/Div";
import { H3 } from "@components/Heading";

import { BANK_ID_SCOPES } from "@utils/enum";

import { LoginCredentialsForm, LoginOptionsSeparator } from "./components";

import { useLoginSharedData } from "../../hooks";
import { useLoginCredentialsStep } from "./LoginCredentialsStep.hooks";

const LoginCredentialsStep = () => {
  const { messages } = useIntl();
  const { handleSubmitLogin } = useLoginCredentialsStep();
  const { sharedData } = useLoginSharedData();

  return (
    <Div
      px={[3, 3, 4, 4]}
      py="24px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gridGap={3}
    >
      <H3 textTransform="none" color="var(--blue-dark) !important">
        {messages.title_log_in_with_email}
      </H3>

      <LoginCredentialsForm
        onSubmit={handleSubmitLogin}
        onError={sharedData?.errorCallback}
      />

      <LoginOptionsSeparator />

      <H3 textTransform="none" color="var(--blue-dark) !important">
        {messages.title_bankid_login}
      </H3>

      <Div width={1} maxWidth="200px">
        <BankIDLogin
          scope={BANK_ID_SCOPES.LOGIN}
          buttonLabel={messages.login}
          onSuccess={sharedData?.successCallback}
          onError={sharedData?.errorCallback}
        />
      </Div>
    </Div>
  );
};

export default LoginCredentialsStep;
